<!-- ── Hero Banner ──────────────────────────────────────────────────────────── -->
<section class="banarhome">

  <!-- Layer 1 · Full-bleed background image -->
  <div class="hero-bg">
    <img src="assets/images/homepanar.jpeg" alt="" aria-hidden="true" />
  </div>

  <!-- Layer 2 · Warm colour wash -->
  <div class="hero-overlay"></div>

  <!-- Layer 3 · Floating glass orbs -->
  <div class="hero-orb hero-orb--1"></div>
  <div class="hero-orb hero-orb--2"></div>
  <div class="hero-orb hero-orb--3"></div>

  <div class="container hero-container">

    <!-- Layer 4 · Outer frosted shell -->
    <div class="hero-glass-wrap">

      <!-- Layer 5 · Inner warm glass panel -->
      <div class="hero-glass-panel">
        <div class="hero-content">

          <h1 class="hero-title">
            {{ 'hero.title1' | translate }}
            <em>{{ 'hero.title2' | translate }}</em>
          </h1>

          <div class="hero-divider">
            <span></span>
            <span class="hero-diamond"></span>
            <span></span>
          </div>
          <div class="hero-actions">
            <a routerLink="/shop" class="hero-cta-solid">{{ 'hero.cta.shop' | translate }}</a>
            <a routerLink="/categories" class="hero-cta-ghost">
              {{ 'hero.cta.explore' | translate }} <i class="ti-arrow-right"></i>
            </a>
          </div>

          <div class="hero-trust">
            <div class="trust-item">
              <strong>{{ 'hero.trust.brands_num' | translate }}</strong>
              <span>{{ 'hero.trust.brands_label' | translate }}</span>
            </div>
            <div class="trust-sep"></div>
            <div class="trust-item">
              <strong>{{ 'hero.trust.auth_num' | translate }}</strong>
              <span>{{ 'hero.trust.auth_label' | translate }}</span>
            </div>
            <div class="trust-sep"></div>
            <div class="trust-item">
              <strong>{{ 'hero.trust.fast' | translate }}</strong>
              <span>{{ 'hero.trust.delivery_label' | translate }}</span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

</section>

<!-- ── Product of the Week ────────────────────────────────────────────────── -->
<section class="potw-section scroll-reveal" *ngIf="featuredProduct" #potwSection>
  <div class="potw-parallax-bg" #potwParallaxBg></div>
  <div class="potw-orb potw-orb--1"></div>
  <div class="potw-orb potw-orb--2"></div>

  <div class="container potw-container">

    <h2 class="potw-section-title">{{ 'potw.eyebrow' | translate }}</h2>

    <div class="potw-stage" [routerLink]="['/products_details', featuredProduct.id]">

      <!-- Medallion: concentric rings + circular image -->
      <div class="potw-medallion">
        <div class="potw-floral"></div>
        <div class="potw-ring potw-ring--outer"></div>
        <div class="potw-ring potw-ring--mid"></div>

        <!-- Cardinal tick marks -->
        <div class="potw-tick potw-tick--n"></div>
        <div class="potw-tick potw-tick--s"></div>
        <div class="potw-tick potw-tick--e"></div>
        <div class="potw-tick potw-tick--w"></div>

        <div class="potw-halo"></div>

        <div class="potw-img-wrap">
          <img
            [src]="featuredProduct.images[0]?.image_url || 'assets/images/rk.jpeg'"
            [alt]="featuredProduct.name"
            class="potw-img"
          />
          <div class="potw-img-shimmer"></div>
        </div>
      </div>

      <div class="potw-divider">
        <span></span><span class="potw-diamond"></span><span></span>
      </div>

      <div class="potw-info">
        <h2 class="potw-title">{{ featuredProduct.name }}</h2>
        <p class="potw-name-ar" *ngIf="featuredProduct.name_ar" dir="rtl">{{ featuredProduct.name_ar }}</p>

        <div class="potw-price-row">
          <span class="potw-price-was" *ngIf="featuredProduct.discount > 0">LE {{ featuredProduct.price }}</span>
          <span class="potw-price">LE {{ effectivePrice(featuredProduct) }}</span>
          <span class="potw-badge-disc" *ngIf="featuredProduct.discount > 0">-{{ featuredProduct.discount }}%</span>
        </div>

        <a class="potw-cta">{{ 'potw.cta' | translate }} <i class="ti-arrow-right"></i></a>
      </div>

    </div>
  </div>
</section>

<!-- ── All Categories ──────────────────────────────────────────────────────── -->
<section class="feat-product">
  <div class="container">
    <div class="cat-section-header scroll-reveal">
      <h2 class="cat-main-title">{{ 'cats.title1' | translate }} <em>{{ 'cats.title2' | translate }}</em></h2>
      <p class="cat-main-sub">{{ 'cats.sub' | translate }}</p>
    </div>
  </div>

  <div class="cat-rail-shell">
    <div class="cat-rail-track scroll-reveal" #catRailTrack>
      <a class="cat-rail-tile" *ngFor="let item of category" [routerLink]="['/Products', item?.id]">
        <img [src]="item?.image?.image_url" [alt]="item?.name" loading="lazy" />
        <div class="cat-rail-scrim">
          <h5 class="cat-rail-name">{{ item?.name }}</h5>
          <span class="cat-rail-arrow"><i class="ti-arrow-right"></i></span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ── Why Us ─────────────────────────────────────────────────────────────── -->
<section class="why-strip">
  <div class="container">
    <div class="why-grid">
      <div class="why-item scroll-reveal">
        <span class="why-ornament">✦</span>
        <h4>{{ 'why.chat.title' | translate }}</h4>
        <p>{{ 'why.chat.body' | translate }}</p>
      </div>
      <div class="why-sep"></div>
      <div class="why-item scroll-reveal" style="transition-delay: 0.14s">
        <span class="why-ornament">✦</span>
        <h4>{{ 'why.request.title' | translate }}</h4>
        <p>{{ 'why.request.body' | translate }}</p>
      </div>
      <div class="why-sep"></div>
      <div class="why-item scroll-reveal" style="transition-delay: 0.28s">
        <span class="why-ornament">✦</span>
        <h4>{{ 'why.brands.title' | translate }}</h4>
        <p>{{ 'why.brands.body' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ── Our Brands ─────────────────────────────────────────────────────────── -->
<section class="brands-section">
  <div class="container">
    <div class="sec-heading scroll-reveal">
      <h2 class="sec-title">{{ 'brands.title' | translate }}</h2>
    </div>
    <div class="text-center brands-wrap scroll-reveal" style="transition-delay: 0.12s">
      <img src="assets/images/prands.png" alt="Our Brands" />
    </div>
  </div>
</section>

<!-- ── Editorial Cover ────────────────────────────────────────────────────── -->
<section class="editorial-cover scroll-reveal">
  <div class="editorial-orb editorial-orb--1"></div>
  <div class="editorial-orb editorial-orb--2"></div>
  <div class="editorial-inner">
    <h2 class="editorial-title">
      {{ 'edit.title1' | translate }}<br><em>{{ 'edit.title2' | translate }}</em>
    </h2>
    <p class="editorial-sub">{{ 'edit.sub' | translate }}</p>
    <a routerLink="/shop" class="editorial-cta">{{ 'edit.cta' | translate }}</a>
  </div>
</section>

<!-- ── Best Sellers ───────────────────────────────────────────────────────── -->
<section class="bestsellers-section">
  <div class="container">

    <div class="bs-header scroll-reveal">
      <h2 class="bs-title">{{ 'bs.title1' | translate }} <em>{{ 'bs.title2' | translate }}</em></h2>
      <p class="bs-sub">{{ 'bs.sub' | translate }}</p>
    </div>

    <div class="bs-slider-wrap scroll-reveal" *ngIf="topProducts.length">
      <swiper [config]="bsSwiperConfig" class="bs-swiper" dir="ltr">
        <ng-template swiperSlide *ngFor="let item of topProducts; let i = index">
          <div class="bs-card" [routerLink]="['/products_details', item.id]">
            <span class="bs-rank-pill" *ngIf="i === 0">{{ 'bs.rank' | translate }}</span>
            <div class="bs-img-wrap">
              <img [src]="item.images[0]?.image_url || 'assets/images/rk.jpeg'"
                   [alt]="item.name" loading="lazy" />
              <div class="bs-overlay"><span class="bs-cta">{{ 'bs.cta' | translate }}</span></div>
            </div>
            <div class="bs-info">
              <h4 class="bs-name">{{ item.name }}</h4>
              <div class="bs-price-row">
                <span class="bs-price-was" *ngIf="item.discount > 0">LE {{ item.price }}</span>
                <span class="bs-price">LE {{ effectivePrice(item) }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>

    <div class="text-center mt-5 scroll-reveal" style="transition-delay: 0.48s">
      <a routerLink="/shop" class="btn-outline-luxury btn">{{ 'bs.view_all' | translate }}</a>
    </div>
  </div>
</section>

<!-- ── Editorial Mood Banner ──────────────────────────────────────────────── -->
<section class="mood-banner scroll-reveal">
  <div class="mood-inner">
    <h2>{{ 'mood.quote' | translate }}</h2>
    <a routerLink="/shop" class="btn-minimal">{{ 'mood.cta' | translate }}</a>
  </div>
</section>

<!-- ── Trending Packages ───────────────────────────────────────────────────── -->
<section *ngIf="ifPackages" class="packages-section">
  <div class="container">
    <div class="sec-heading scroll-reveal">
      <h2 class="sec-title">{{ 'packs.title' | translate }}</h2>
    </div>

    <div class="row g-4 justify-content-center">
      <div
        class="col-6 col-md-4 col-lg-3 scroll-reveal pack-col"
        *ngFor="let item of allPackages; let i = index"
        [style.transition-delay]="(i % 4 * 0.1) + 's'"
        (click)="pack_details(item.id)"
      >
        <div class="pack-card">
          <div class="pack-img-wrap">
            <img [src]="item?.image" [alt]="item?.name" />
          </div>
          <div class="pack-info">
            <h5 class="pack-name">{{ item?.name }}</h5>
            <p class="price">{{ item?.total_price }} <strong>LE</strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
